import {create} from "zustand";
import type {Database} from "@sakura-grp/database/types";

type HostessRow = Database["public"]["Tables"]["hostesses"]["Row"];

// 現在の所属店舗情報を含むホステス型
export type HostessStoreAssignment = {
  store_id: string;
  assigned_from: string;
  store: {id: string; store_name: string | null; logo_path: string | null} | null;
};

export type Hostess = HostessRow & {
  current_assignment?: HostessStoreAssignment[];
};

// ヘルパー関数: 現在の所属店舗IDを取得
export function getCurrentStoreId(hostess: Hostess | null): string | null {
  return hostess?.current_assignment?.[0]?.store_id ?? null;
}

interface HostessState {
  // ログイン中のホステス情報
  hostess: Hostess | null;
  loading: boolean;

  // アクション
  setHostess: (hostess: Hostess | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useHostessStore = create<HostessState>((set) => ({
  // 初期状態
  hostess: null,
  loading: true,

  // アクション
  setHostess: (hostess) => set({hostess, loading: false}),
  setLoading: (loading) => set({loading}),
  clear: () => set({hostess: null, loading: true}),
}));
